import type { ReactNode } from 'react';

interface BulkSelectionBarProps {
    selectionLabel: string;
    onClear: () => void;
    children?: ReactNode;
}

export const BulkSelectionBar = ({ selectionLabel, onClear, children }: BulkSelectionBarProps) => (
    <div
        className="bg-cocoa-900 fixed bottom-6 left-1/2 z-40 flex -translate-x-1/2 items-center gap-3 rounded-lg px-4 py-3 text-sm tracking-[-0.02em] whitespace-nowrap text-white shadow-lg"
        aria-live="polite"
    >
        <span className="font-medium">{selectionLabel} selected</span>
        <button type="button" onClick={onClear} className="text-cocoa-300 text-[13px] font-medium hover:text-white">
            Clear
        </button>
        {children}
    </div>
);
